/* Replace It theme */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast ---------- */
  var toastT;
  function toast(html) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = html; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 3200);
  }
  window.RI = { toast: toast };

  /* ---------- announcement: hold, then fade to next ---------- */
  $$('.announce').forEach(function (bar) {
    var msgs = $$('.msg', bar), i = 0, ms = parseInt(bar.getAttribute('data-rotate'), 10) || 5000;
    if (msgs.length < 2 || reduced) return;
    setInterval(function () { msgs[i].classList.remove('on'); i = (i + 1) % msgs.length; msgs[i].classList.add('on'); }, ms);
  });

  /* ---------- mega menu ---------- */
  (function () {
    var header = $('#siteHeader'), overlay = $('#megaOverlay'), nav = $('#mainnav');
    if (!header || !nav) return;
    var items = $$('.navitem', nav);
    function closeAll() {
      items.forEach(function (it) { it.classList.remove('open'); var b = $('button', it); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (overlay) overlay.classList.remove('show');
      header.classList.remove('mega-open');
    }
    function open(item) {
      closeAll();
      var top = header.getBoundingClientRect().bottom;
      if (overlay) overlay.style.top = top + 'px';
      header.classList.add('mega-open');
      item.classList.add('open'); $('button', item).setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('show');
    }
    items.forEach(function (item) {
      var btn = $('button', item);
      btn.addEventListener('click', function (e) { e.stopPropagation(); if (item.classList.contains('open')) closeAll(); else open(item); });
      item.addEventListener('mouseenter', function () { open(item); });
    });
    nav.addEventListener('mouseleave', closeAll);
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    window.addEventListener('scroll', function () { if (overlay && overlay.classList.contains('show')) closeAll(); }, { passive: true });
  })();

  /* ---------- move the drop-downs and phone menu out of the sticky header, so phones scroll them freely ---------- */
  (function () {
    var vh = function () { document.documentElement.style.setProperty('--app-h', ((window.visualViewport && window.visualViewport.height) || window.innerHeight) + 'px'); };
    vh(); window.addEventListener('resize', vh); window.addEventListener('orientationchange', vh);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', vh);
    ['ddOverlay', 'ddSearch', 'ddBag', 'mnav'].forEach(function (id) { var el = document.getElementById(id); if (el && el.parentNode !== document.body) document.body.appendChild(el); });
    Array.prototype.slice.call(document.querySelectorAll('.mnav-panel')).forEach(function (el) { if (el.parentNode !== document.body) document.body.appendChild(el); });
  })();

  /* ---------- search and bag drop-downs ---------- */
  (function () {
    var hdr = $('#siteHeader'), overlay = $('#ddOverlay');
    if (!hdr || !overlay) return;
    var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
    var panels = { search: $('#ddSearch'), bag: $('#ddBag') }, btns = { search: $('#searchOpen'), bag: $('#cartIcon') };
    var cur = null, timers = {}, narrow = function () { return window.innerWidth <= 980; };
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(cents, cur_) {
      var c = cur_ || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: c }).format(cents / 100); } catch (e) { return '£' + (cents / 100).toFixed(2); }
    }
    function hide(name, instant) {
      var p = panels[name]; if (!p) return;
      clearTimeout(timers[name]);
      p.classList.remove('open');
      if (!instant && !reduced) { p.classList.add('closing'); timers[name] = setTimeout(function () { p.classList.remove('closing'); }, 260); }
      else p.classList.remove('closing');
      p.setAttribute('aria-hidden', 'true');
      if (btns[name]) { btns[name].setAttribute('aria-expanded', 'false'); }
    }
    function close(instant) {
      if (!cur) return;
      var was = cur; cur = null;
      hide(was, instant);
      overlay.classList.remove('show');
      document.body.classList.remove('dd-lock');
      if (!instant && btns[was] && document.activeElement && panels[was].contains(document.activeElement)) btns[was].focus({ preventScroll: true });
    }
    function open(name) {
      var p = panels[name]; if (!p) return;
      if (cur === name) return;
      if (window.RI && RI.closeMenu) RI.closeMenu();
      if (cur) hide(cur, true);
      clearTimeout(timers[name]); p.classList.remove('closing');
      var top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--dd-top', top + 'px');
      p.classList.add('open'); p.setAttribute('aria-hidden', 'false');
      if (btns[name]) btns[name].setAttribute('aria-expanded', 'true');
      overlay.classList.add('show');
      if (narrow()) document.body.classList.add('dd-lock');
      cur = name;
      if (name === 'search') { var inp = $('#ddInput'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 60); }
    }
    function toggle(name) { if (cur === name) close(); else open(name); }
    window.RI.openDD = open; window.RI.closeDD = close;
    if (btns.search) btns.search.addEventListener('click', function () { toggle('search'); });
    if (btns.bag) btns.bag.addEventListener('click', function () { toggle('bag'); });
    overlay.addEventListener('click', function () { close(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-dd-close]')) { close(); return; }
      if (cur && e.target.closest) {
        var a = e.target.closest('.dd a'); if (a && !a.hasAttribute('data-keep')) close(true);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) close(); });
    window.addEventListener('resize', function () { if (cur) { var t = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)); document.documentElement.style.setProperty('--dd-top', t + 'px'); document.body.classList.toggle('dd-lock', narrow()); } });

    /* live search */
    var input = $('#ddInput'), quick = $('#ddQuick'), results = $('#ddResults'), st, ctrl, lastQ = '';
    function showQuick() { if (results) results.hidden = true; if (quick) quick.hidden = false; }
    function renderResults(q, products) {
      var h = '';
      if (products.length) {
        h += '<h5>Products</h5><ul class="sr-list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=140' : '';
          var price = p.price ? '£' + Number(p.price).toFixed(2) : '';
          try { price = new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(Number(p.price)); } catch (e) {}
          h += '<li><a href="' + esc(p.url) + '"><span class="sr-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><span class="sr-t">' + esc(p.title) + '</span><span class="sr-p">' + esc(price) + '</span></a></li>';
        });
        h += '</ul><a class="sr-all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '” <i aria-hidden="true">→</i></a>';
      } else {
        h = '<p class="sr-none">No matches for “' + esc(q) + '”. Try the part number or the model, or <a href="' + root + 'pages/contact">ask us</a>.</p>';
      }
      results.innerHTML = h; results.hidden = false; if (quick) quick.hidden = true;
    }
    if (input && window.fetch) {
      input.addEventListener('input', function () {
        clearTimeout(st);
        var q = input.value.trim();
        if (q.length < 2) { if (ctrl) ctrl.abort(); lastQ = ''; showQuick(); return; }
        st = setTimeout(function () {
          if (q === lastQ) return; lastQ = q;
          if (ctrl && ctrl.abort) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.sku,product_type,tag,vendor';
          fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
            var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
            renderResults(q, list);
          }).catch(function () {});
        }, 180);
      });
    }

    /* bag */
    var body = $('#bagBody');
    function setCount(n) {
      var icon = btns.bag; if (!icon) return;
      var c = $('.cart-count', icon);
      if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'cart-count'; icon.appendChild(c); } c.textContent = n; }
      else if (c) c.remove();
      icon.setAttribute('aria-label', 'Bag, ' + n + ' items');
    }
    function renderBag(cart) {
      setCount(cart.item_count);
      if (!body) return;
      var shop = body.getAttribute('data-shop') || '/collections/all';
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<h3 class="bag-h">Your Bag is empty.</h3><p class="bag-sub">Free UK delivery on every order.</p><a class="btn btn-line btn-sm" href="' + esc(shop) + '">Continue shopping</a>';
        return;
      }
      var h = '<h3 class="bag-h">Your Bag</h3><ul class="bag-list">';
      cart.items.forEach(function (it) {
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        h += '<li class="bi" data-key="' + esc(it.key) + '"><a class="bi-img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</a>' +
          '<div class="bi-main"><a class="bi-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (v ? '<span class="bi-v">' + esc(v) + '</span>' : '') +
          '<div class="bi-q"><button type="button" data-q="-1" aria-label="One fewer">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="1" aria-label="One more">+</button><button type="button" class="bi-rm" data-q="0">Remove</button></div></div>' +
          '<div class="bi-p">' + money(it.final_line_price, cart.currency) + '</div></li>';
      });
      h += '</ul><div class="bag-total"><span>Subtotal</span><b>' + money(cart.total_price, cart.currency) + '</b></div>' +
        '<p class="bag-sub">Free UK delivery on every order.</p>' +
        '<div class="bag-ctas"><a class="btn btn-dark" href="' + esc(body.getAttribute('data-checkout')) + '" data-keep>Check out</a><a class="btn btn-line" href="' + esc(body.getAttribute('data-cart')) + '">Review bag</a></div>';
      body.innerHTML = h;
    }
    function getCart() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    window.RI.cart = { render: renderBag, refresh: function () { return getCart().then(function (c) { renderBag(c); return c; }); } };
    if (window.fetch) { var go = function () { window.RI.cart.refresh().catch(function () {}); }; if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 400); }
    if (body) body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]'); if (!b) return;
      var li = b.closest('.bi'); if (!li) return;
      var key = li.getAttribute('data-key'), d = parseInt(b.getAttribute('data-q'), 10);
      var qty = d === 0 ? 0 : parseInt($('.bi-q span', li).textContent, 10) + d;
      if (qty < 0) qty = 0;
      li.classList.add('busy');
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { if (c && c.items) renderBag(c); else li.classList.remove('busy'); })
        .catch(function () { li.classList.remove('busy'); });
    });
  })();

  /* ---------- phone menu with drill-down panels ---------- */
  (function () {
    var m = $('#mnav'); if (!m) return;
    var openBtn = $('#menuOpen'), closeBtn = $('#menuClose');
    var panelEls = $$('.mnav-panel');
    function closePanels() { m.classList.remove('sub-open'); panelEls.forEach(function (p) { p.classList.remove('open'); p.setAttribute('aria-hidden', 'true'); }); }
    var hdr = $('#siteHeader'), timer;
    window.RI.closeMenu = function () { set(false); };
    function set(o) {
      clearTimeout(timer);
      var isOpen = m.classList.contains('open');
      if (o === isOpen && !m.classList.contains('closing')) return;
      m.classList.remove('closing');
      if (o) {
        if (window.RI && RI.closeDD) RI.closeDD(true);
        var top = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
        document.documentElement.style.setProperty('--mnav-top', top + 'px');
        m.classList.add('open');
      } else {
        m.classList.remove('open');
        if (!reduced) { m.classList.add('closing'); timer = setTimeout(function () { m.classList.remove('closing'); }, 300); }
      }
      m.setAttribute('aria-hidden', !o);
      document.body.style.overflow = o ? 'hidden' : '';
      if (openBtn) { openBtn.classList.toggle('is-open', o); openBtn.setAttribute('aria-expanded', o ? 'true' : 'false'); openBtn.setAttribute('aria-label', o ? 'Close menu' : 'Open menu'); }
      if (!o) closePanels();
    }
    window.addEventListener('resize', function () { if (window.innerWidth > 980) set(false); });
    if (openBtn) openBtn.addEventListener('click', function () { set(!m.classList.contains('open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { set(false); });
    function onMenuClick(e) {
      var sub = e.target.closest('a.has-sub');
      if (sub) {
        e.preventDefault();
        var p = document.getElementById(sub.getAttribute('data-panel'));
        if (p) { p.scrollTop = 0; m.classList.add('sub-open'); p.classList.add('open'); p.setAttribute('aria-hidden', 'false'); var bk = $('.mp-back', p); if (bk) setTimeout(function () { bk.focus({ preventScroll: true }); }, 60); }
        return;
      }
      if (e.target.closest('.mp-back')) { closePanels(); return; }
      if (e.target.closest('.mp-x')) { set(false); return; }
      if (e.target.closest('a')) set(false);
    }
    m.addEventListener('click', onMenuClick);
    panelEls.forEach(function (p) { p.addEventListener('click', onMenuClick); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !m.classList.contains('open')) return;
      var openPanel = $('.mnav-panel.open');
      if (openPanel) closePanels(); else set(false);
    });
  })();

  /* ---------- in-page links: smooth scroll under the sticky header ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || a.closest('#mnav a.has-sub')) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var el = document.getElementById(id); if (!el) return;
    e.preventDefault();
    scrollToEl(el);
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
  function scrollToEl(el) {
    var hdr = $('#siteHeader');
    var t = el.classList.contains('sec') ? ($('.wrap > *', el) || el) : el;
    var top = t.getBoundingClientRect().top + window.pageYOffset - (hdr ? hdr.offsetHeight : 0) - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
  }

  /* ---------- models row: native scroll + mouse drag with momentum ---------- */
  $$('.models').forEach(function (row) {
    var wrap = row.parentElement, bar = $('.mprog b', wrap);
    function prog() {
      if (!bar) return;
      var max = row.scrollWidth - row.clientWidth, r = max > 0 ? row.scrollLeft / max : 0;
      var bw = Math.max(0.15, row.clientWidth / Math.max(1, row.scrollWidth));
      bar.style.width = (bw * 100) + '%';
      bar.style.transform = 'translateX(' + (r * (1 / bw - 1) * 100) + '%)';
      bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    row.addEventListener('scroll', prog, { passive: true }); window.addEventListener('resize', prog); prog();
    var down = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, raf = 0;
    function stop() { cancelAnimationFrame(raf); }
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      stop(); down = true; moved = false; sx = lx = e.clientX; sl = row.scrollLeft; lt = performance.now(); v = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 4) { moved = true; row.classList.add('drag'); }
      if (!moved) return;
      var now = performance.now(), dt = Math.max(1, now - lt);
      v = 0.8 * v + 0.2 * ((lx - e.clientX) / dt * 16); lx = e.clientX; lt = now;
      row.scrollLeft = sl - dx; e.preventDefault();
    }, { passive: false });
    function end() {
      if (!down) return; down = false;
      if (!moved) return;
      if (performance.now() - lt > 80) v = 0;
      (function step() { row.scrollLeft += v; v *= 0.95; if (Math.abs(v) > 0.3) raf = requestAnimationFrame(step); else row.classList.remove('drag'); })();
    }
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
    row.addEventListener('wheel', stop, { passive: true }); row.addEventListener('touchstart', stop, { passive: true });
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('keydown', function (e) {
      var card = $('.model', row); if (!card) return;
      var w = card.offsetWidth + 20;
      if (e.key === 'ArrowRight') { row.scrollBy({ left: w, behavior: 'smooth' }); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { row.scrollBy({ left: -w, behavior: 'smooth' }); e.preventDefault(); }
    });
  });

  /* ---------- reviews: pages that slide ---------- */
  $$('[data-reviews-track]').forEach(function (track) {
    var sec = track.closest('section'), dots = $$('[data-reviews-dots] button', sec);
    if (dots.length < 2) return;
    var idx = 0, timer, vp = track.parentElement;
    function go(i) { idx = i; track.style.transform = 'translateX(-' + (idx * 100) + '%)'; dots.forEach(function (d, di) { d.classList.toggle('active', di === idx); }); }
    function start() { clearInterval(timer); if (!reduced) timer = setInterval(function () { go((idx + 1) % dots.length); }, 6000); }
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); start(); }); });
    vp.addEventListener('mouseenter', function () { clearInterval(timer); });
    vp.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- parts finder ---------- */
  $$('[data-finder]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = $('[data-finder-select]', f);
      if (s && s.value) window.location.href = s.value;
      else if (s) s.focus();
    });
  });

  /* ---------- accordions and FAQs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.acc > button, .faq > button, .fg > .fg-t');
    if (!b) return;
    var p = b.parentElement;
    if (p.classList.contains('fg')) { p.classList.toggle('shut'); b.setAttribute('aria-expanded', !p.classList.contains('shut')); return; }
    p.classList.toggle('open'); b.setAttribute('aria-expanded', p.classList.contains('open'));
  });

  /* ---------- collection filters ---------- */
  (function () {
    var form = $('[data-facet-form]'), panel = $('#filters');
    function go() {
      if (!form) return;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var url = window.location.pathname + '?' + params.toString();
      if (panel && panel.classList.contains('open')) sessionStorageSafe('ri-filters-open', window.location.pathname);
      window.location.href = url;
    }
    function sessionStorageSafe(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
    if (form) {
      var t;
      form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-price')) return; go(); });
      form.addEventListener('input', function (e) { if (!e.target.hasAttribute('data-price')) return; clearTimeout(t); t = setTimeout(go, 900); });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    }
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sort.value); params.delete('page');
      window.location.href = window.location.pathname + '?' + params.toString();
    });
    function openP() { if (!panel) return; panel.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeP() { if (!panel) return; panel.classList.remove('open'); document.body.style.overflow = ''; sessionStorageSafe('ri-filters-open', null); }
    $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', openP); });
    $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', closeP); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeP(); });
    // keep the phone filter panel open only for the reload that a filter change causes, on the same page; the flag is used once, so it can never reopen the panel on another page
    var flag = sessionStorageSafe('ri-filters-open');
    sessionStorageSafe('ri-filters-open', null);
    if (panel && flag === window.location.pathname && window.matchMedia('(max-width: 860px)').matches) { panel.style.transition = 'none'; openP(); requestAnimationFrame(function () { panel.style.transition = ''; }); }
    // coming back with the browser Back button must never show a stuck panel
    window.addEventListener('pageshow', function (e) { if (e.persisted && panel && panel.classList.contains('open')) closeP(); });
  })();

  /* ---------- product page ---------- */
  (function () {
    var sec = $('[data-product-section]'); if (!sec) return;
    // gallery
    var slides = $$('.gal-slide', sec), thumbs = $$('[data-thumb]', sec), cap = $('[data-gal-cap]', sec), cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; s.classList.toggle('on', k === cur); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
      if (cap) cap.textContent = slides[cur].getAttribute('data-caption') || '';
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    sec.addEventListener('keydown', function (e) {
      if (!e.target.hasAttribute('data-thumb')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { show(cur + (e.key === 'ArrowRight' ? 1 : -1)); thumbs[cur].focus(); e.preventDefault(); }
    });
    var main = $('[data-gal-main]', sec), x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    show(0);

    // quantity
    var qty = $('[data-qty]', sec);
    $$('[data-q]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var max = parseInt(qty.max, 10) || 99, v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-q'), 10);
        qty.value = Math.max(1, Math.min(max, v));
      });
    });

    // variants
    var vjson = $('[data-variants]', sec), selects = $$('[data-option]', sec), idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add]', sec), priceEl = $('[data-price]', sec), stock = $('[data-stock]', sec), mbarPrice = $('[data-mbar-price]');
    var money = function (c) { var v = c / 100; return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
    if (vjson && selects.length) {
      var variants = JSON.parse(vjson.textContent);
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var vals = selects.map(function (x) { return x.value; });
          var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
          if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (mbarPrice) mbarPrice.textContent = money(v.price);
          if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to bag' : 'Out of stock'; }
          if (stock) stock.innerHTML = v.available ? '<span class="dot"></span>' + (stock.getAttribute('data-in') || 'In stock') : '<span class="dot out"></span>Out of stock';
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        });
      });
    }

    // add to bag without leaving the page
    var form = $('[data-product-form]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = $('[data-form-error]', sec), btns = $$('button[type="submit"]').filter(function (b) { return b.form === form; });
        btns.forEach(function (b) { b.disabled = true; });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to bag.');
            if (err) err.hidden = true;
            return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              if (window.RI && RI.cart && RI.openDD) { RI.cart.render(cart); RI.openDD('bag'); }
              else toast('<span>Added to your bag</span><a href="' + ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart') + '">View bag</a>');
            });
          })
          .catch(function (e2) { if (err) { err.textContent = e2.message; err.hidden = false; } })
          .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
      });
    }

    // sticky buy bar on phones
    var mbar = $('[data-mbar]');
    if (mbar && addBtn) {
      var upd = function () { mbar.classList.toggle('show', addBtn.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', upd, { passive: true }); upd();
    }
  })();

  /* ---------- product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length || !window.fetch) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = $('[data-recs]', d);
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ---------- bag page: update when quantity changes ---------- */
  $$('[data-cart-qty]').forEach(function (i) {
    var t; i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { i.form.submit(); }, 300); });
  });

  /* ---------- document pages: build the "On this page" list ---------- */
  $$('[data-toc]').forEach(function (toc) {
    var doc = toc.parentElement.querySelector('.doc'); if (!doc) return;
    var hs = $$('h2[id]', doc);
    if (hs.length < 2) { toc.style.display = 'none'; return; }
    hs.forEach(function (h) { var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; a.setAttribute('data-id', h.id); toc.appendChild(a); });
    var links = $$('a', toc);
    window.addEventListener('scroll', function () {
      var on = null; hs.forEach(function (h) { if (h.getBoundingClientRect().top < 140) on = h.id; });
      links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('data-id') === on); });
    }, { passive: true });
  });

  /* ---------- contact form: pre-select topic from ?topic= ---------- */
  (function () {
    var s = $('[data-topic]'); if (!s) return;
    var t = new URLSearchParams(window.location.search).get('topic'); if (!t) return;
    t = t.toLowerCase();
    for (var i = 0; i < s.options.length; i++) { if (s.options[i].value.toLowerCase().indexOf(t) > -1) { s.selectedIndex = i; break; } }
  })();

  /* ---------- scroll to #anchor on load (under the sticky header) ---------- */
  window.addEventListener('load', function () {
    if (!location.hash || location.hash.length < 2) return;
    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (el) setTimeout(function () { scrollToEl(el); }, 60);
  });
})();
